<div class="p-2">
  <!-- Title -->
  <div class="row">
    <div class="col-12 h5 text-muted p-0">Circulars</div>
  </div>

  <div class="row bg-light">
    <div class="col-12 p-2">

      <!-- Filters -->
      <div class="row bg-white m-0">
        <div class="col-12">
          <div class="row mt-2 mb-2">
            <div class="col-4">
              <select class="form-select text-muted" [(ngModel)]="selectedStore" (change)="onStoreChange($event)" [disabled]="circularsLoading === true" *ngIf="stores.length > 0">
                <option *ngFor="let store of stores" [value]="store.store_id">{{ store.store_name }} ({{ store.store_circular_count }})</option>
              </select>
            </div>
            <div class="col-8">
              <div class="spinner-grow spinner-grow-sm text-info" role="status" *ngIf="storesLoading === true"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Circulars -->
      <div class="row mt-4 pt-4 mb-4 pb-4 text-center" *ngIf="circularsLoading === true">
        <div class="col-12">
          <div class="spinner-border text-info  mt-4" role="status"></div>
        </div>
      </div>

      <div class="row mt-2 pt-2 pb-4">
        <div class="col-12">
          <div class="row text-center mt-4 mb-4" *ngIf="storesLoading == false && circularsLoading == false && circulars.length == 0">
            <i-bs class="text-black-50 mt-4 pt-4" name="collection" width="30" height="30"></i-bs>
            <div class="col-12 mb-4 pb-4 text-black-50">Circulars not found</div>
          </div>

          <div class="row">
            <div class="col-12">
              <pagination-controls class="float-end" style="font-size:12px" maxSize="4" autoHide="true" previousLabel=""
                nextLabel="" (pageChange)="onCircularsPageChange($event)" *ngIf="circularsCount > 0"></pagination-controls>
            </div>
          </div>

          <div class="row" *ngIf="circularsLoading === false && circulars.length > 0">
            <div class="col-12 col-md-4 mb-3" *ngFor="let circular of circulars | paginate: { itemsPerPage: 9, currentPage: circularsPage, totalItems: circularsCount }; let i = index;">

              <div class="card circular-outer position-relative">
                <div class="position-absolute top-0 end-0">
                  <i-bs class="text-secondary cursor-pointer" name="pencilSquare" title="Edit Circular" (click)="onEditCircular(circular)"></i-bs>&nbsp;&nbsp;
                </div>

                <div class="card-body text-center cursor-pointer" (click)="showCircularPreviewModal(circular, circular_preview_modal)">

                  <div class="title text-muted mt-1 mb-2" [title]="circular?.name">{{ circular?.name }}</div>

                  <img class="img img-fluid mt-1 mb-2" [src]="circular?.images[0].name" alt="...">

                  <div class="row">
                    <div class="col-12">
                      <span class="circular-date text-muted float-start pt-1">
                        <i-bs class="text-info" name="calendarCheck" title="Circular Date"></i-bs>
                        {{ circular?.start_date | date : 'MMM d, y' : 'UTC' }} - {{ circular?.end_date | date : 'MMM d, y' : 'UTC' }}
                      </span>

                      <span class="float-end">
                        <i-bs class="text-info" name="collection" title="Circular Pages"></i-bs>
                        <span class="page-no text-muted">
                          &nbsp;{{ circular?.images.length }}
                          <span *ngIf="circular?.images.length == 1">Page</span>
                          <span *ngIf="circular?.images.length > 1">Pages</span>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <pagination-controls class="float-end" style="font-size:12px" maxSize="4" autoHide="true" previousLabel=""
                nextLabel="" (pageChange)="onCircularsPageChange($event)" *ngIf="circularsCount > 0"></pagination-controls>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Circular Preview Modal -->
<ng-template #circular_preview_modal>
  <div class="modal-header">
    <h6 class="modal-title text-muted float-start">{{ circularPreviewData.name }}</h6>
    <i-bs class="text-muted cursor-pointer float-end" name="xCircle" title="Close" (click)="hideCircularPreviewModal()"></i-bs>
  </div>

  <div class="modal-body circular-preview">
    <app-preview-circular page="circular-list" [circularPreviewData]="circularPreviewData"></app-preview-circular>
  </div>
</ng-template>
